export default __webpack_public_path__ + "static/pixaid-4e9cc34fdfae409db93a516c2b9f990b.png";